var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-146.000000, -650.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.000000, 650.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 0,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 3.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(5.500000, 2.642857) rotate(-90.000000) translate(-5.500000, -2.642857) ",
    points: "3 -2 8 2.64285714 3 7.28571429"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 0.5,
    x2: 5.5,
    y2: 9.5,
    strokeLinecap: "square"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.111deb9da2da4ad47133c4af16cb5d93.svg";
export { ForwardRef as ReactComponent };